"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require("react-redux");

var _actions = require("../actions");

var _actions2 = _interopRequireDefault(_actions);

var _lsPopupReact = require("../../lsPopupReact");

var _lsPopupReact2 = _interopRequireDefault(_lsPopupReact);

var _Slider = require("./cartDetail/step1/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _config = require("linksoft/core/config");

var _config2 = _interopRequireDefault(_config);

var _localize = require("linksoft/core/localize");

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

var MidCart = function (_Component) {
    (0, _inherits3.default)(MidCart, _Component);

    function MidCart() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MidCart);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MidCart.__proto__ || (0, _getPrototypeOf2.default)(MidCart)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
            _this.props.updateMidCartVisibility(false);
        }, _this.midCartClose = function (event) {
            _this.props.updateMidCartVisibility(false);
        }, _this.navigateToCart = function (e) {
            if (typeof window !== 'undefined') window.location.href = '/cart';
        }, _this.getPriceSafe = function (item) {
            return (item.resultPrice || {}).finalPrice || item.standardPrice || item.retailPrice || 0;
        }, _this.getPriceAndFormatSafe = function (item) {
            var price = _this.getPriceSafe(item);
            return _this.formatPriceSafe(price);
        }, _this.createCarouselItem = function (item) {
            var imageUrl = (0, _config2.default)().url.productImage({ id: item.id });
            var authorsFormatted = item.literaryAuthors.map(function (a) {
                return a.name;
            }).join(', ');

            return React.createElement(
                "div",
                { className: "carousel-item", key: "midCartCarouselItem_" + item.id },
                React.createElement(
                    "a",
                    { href: "/Product/Detail/" + item.id },
                    React.createElement(
                        "figure",
                        { className: "carousel-thumbnail" },
                        React.createElement("img", { src: imageUrl, alt: item.name })
                    ),
                    React.createElement(
                        "div",
                        { className: "carousel-title" },
                        item.name
                    ),
                    React.createElement(
                        "div",
                        { className: "carousel-author" },
                        authorsFormatted
                    ),
                    React.createElement(
                        "div",
                        { className: "carousel-price" },
                        _this.getPriceAndFormatSafe(item) + " " + Resx.App.Currency
                    )
                ),
                React.createElement(
                    "div",
                    { className: "carousel-add-to-cart" },
                    React.createElement(
                        "button",
                        { className: "btn", onClick: function onClick(event) {
                                _this.addToCart(event, item);
                            } },
                        React.createElement("i", { className: "icon--cart" }),
                        Resx.App.IntoCart
                    )
                )
            );
        }, _this.addToCart = function (event, item) {
            var productInCart = _this.props.cart.items.find(function (i) {
                return i.id === item.id;
            });

            item.productId = item.id;
            item.productName = item.name;
            item.amount = !productInCart ? 1 : productInCart.amount + 1;
            item.price = _this.getPriceSafe(item);
            _this.props.submitChanges(item);
        }, _this.showDelivery = function () {
            try {
                var message = Resx.App.BuyMoreForAndYouCanHaveShippingForFreeMessage;

                var cart = _this.props.cart;
                var limit = cart.minOrderPriceForFreeDelivery,
                    totalPrice = cart.totalPrice;

                if (limit === undefined || limit === null) {
                    limit = (_this.props.deliveryTypeLimits || {}).limit;
                }
                if (!limit || !totalPrice || !totalPrice.finalPrice) return '';

                var diff = limit - totalPrice.finalPrice;
                if (diff > 0) {
                    var replacement = limit + " " + Resx.App.Currency;
                    message = message.replace('{0}', replacement);
                    return React.createElement(
                        "div",
                        null,
                        _this.getDeliveryIcon(),
                        React.createElement("span", { dangerouslySetInnerHTML: { __html: message } })
                    );
                } else {
                    return React.createElement(
                        "div",
                        null,
                        _this.getDeliveryIcon(),
                        Resx.App.YouHaveFreeTransportation
                    );
                }
            } catch (e) {
                console.error("Error in component MidCart, method: showDelivery.", e);
                return '';
            }
        }, _this.getDeliveryIcon = function () {
            return React.createElement(
                "span",
                { className: "mid-cart-delivery-icon" },
                React.createElement("i", { className: "icon--van" })
            );
        }, _this.getNextFreeProduct = function () {
            try {
                if (!_this.props.freeItems || !Array.isArray(_this.props.freeItems)) {
                    return null;
                }
                var cartPrice = _this.props.cart.totalPrice.finalPrice;

                var nextFreeItem = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_this.props.freeItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var fItem = _step.value;

                        // find cheapest product reachable by adding extra products
                        if (fItem.minOrderPrice > cartPrice && (!nextFreeItem || fItem.minOrderPrice < nextFreeItem.minOrderPrice)) nextFreeItem = fItem;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return nextFreeItem;
            } catch (e) {
                console.error("Error in component containers/cart.js, method: getNextFreeProduct.", e);
                return null;
            }
        }, _this.showFreeProducts = function () {
            try {
                if (!_this.props.freeItems || !Array.isArray(_this.props.freeItems)) {
                    console.warn("No free items response is available. Probably they were not loaded properly from server.");
                    return '';
                }
                var nextFreeItem = _this.getNextFreeProduct();
                // nextFreeItem not available means: there is no available free product (it is not an error)
                if (!nextFreeItem) {
                    return '';
                }

                var cartPrice = _this.props.cart.totalPrice.finalPrice;
                return React.createElement(
                    "div",
                    null,
                    Resx.Common.BuyMore,
                    "\xA0",
                    React.createElement(
                        "strong",
                        null,
                        Math.round(nextFreeItem.minOrderPrice - cartPrice)
                    ),
                    "\xA0",
                    Resx.App.Currency,
                    "\xA0",
                    Resx.Common.YouWillHaveForFree,
                    ":\xA0",
                    React.createElement(
                        "strong",
                        null,
                        nextFreeItem.productName
                    )
                );
            } catch (e) {
                console.error("Error in component containers/cart.js, method: showFreeProducts.", e);
                return '';
            }
        }, _this.renderCarouselItems = function () {
            if (!_this.props.carouselItems || !Array.isArray(_this.props.carouselItems)) {
                return '';
            }
            // do not show products already present in cart in carousel
            var cartProdIds = _this.props.cart.items.map(function (ci) {
                return ci.id || ci.productId;
            });
            var carItems = _this.props.carouselItems.filter(function (i) {
                return !(cartProdIds.indexOf(i.id) >= 0 || cartProdIds.indexOf(i.productId) >= 0);
            });

            if (carItems.length === 0) return '';

            return React.createElement(
                _Slider2.default,
                { arrows: carItems.length > 4 },
                carItems.map(_this.createCarouselItem)
            );
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MidCart, [{
        key: "formatPriceSafe",
        value: function formatPriceSafe(price) {
            var _ref2 = this.props.settings || {},
                prices = _ref2.prices;

            if (!price || typeof price !== "number" || !prices || !prices.cultureCode) return price;
            return price.toLocaleString(prices.cultureCode);
        }
    }, {
        key: "render",
        value: function render() {
            var cart = this.props.cart;
            var lastItem = (cart.changedProductId ? cart.items.find(function (i) {
                return i.id === cart.changedProductId;
            }) : null) || [cart.items.length - 1];
            var imageUrl = (0, _config2.default)().url.productImage({ id: lastItem.productId });
            var authorsArray = lastItem.authors || lastItem.literaryAuthorsActive;
            var authors = authorsArray ? authorsArray.map(function (a) {
                return a.Name || a.name;
            }).join(', ') : '';
            var availability = Resx.Common.AmountOnStock + ": " + (lastItem.amountAvailable || 0);
            var price = ((lastItem.price || {}).unitPrice || {}).finalPrice || (lastItem.resultPrice || {}).finalPrice || 0;
            var itemsTotalAmount = 0;
            cart.items.forEach(function (i) {
                return itemsTotalAmount += i.amount;
            });

            return React.createElement(
                _lsPopupReact2.default,
                { title: Resx.App.AddedToCartTitle, close: this.midCartClose, parentClassName: "mid-cart" },
                React.createElement(
                    "div",
                    { className: "mid-cart-detail" },
                    React.createElement(
                        "div",
                        { className: "mid-cart-detail-preview" },
                        React.createElement("img", { src: imageUrl, alt: lastItem.productName })
                    ),
                    React.createElement(
                        "div",
                        { className: "mid-cart-detail-main" },
                        React.createElement(
                            "div",
                            { className: "mid-cart-detail-main-title" },
                            lastItem.productName
                        ),
                        React.createElement(
                            "div",
                            { className: "mid-cart-detail-main-author" },
                            authors
                        ),
                        React.createElement(
                            "div",
                            { className: "detai-row-main-availability hidden" },
                            availability
                        )
                    ),
                    React.createElement(
                        "div",
                        { className: "mid-cart-detail-amount" },
                        "1\xA0",
                        Resx.App.Pcs
                    ),
                    React.createElement(
                        "div",
                        { className: "mid-cart-detail-price" },
                        this.formatPriceSafe(price) + " " + Resx.App.Currency
                    )
                ),
                React.createElement(
                    "div",
                    { className: "mid-cart-buttons" },
                    React.createElement(
                        "button",
                        { className: "btn", onClick: this.midCartClose },
                        Resx.App.BackToShopping
                    ),
                    React.createElement(
                        "button",
                        { className: "btn btn--green", onClick: this.navigateToCart },
                        Resx.App.GoToCart
                    )
                ),
                React.createElement(
                    "div",
                    { className: "mid-cart-delivery" },
                    this.showDelivery()
                ),
                !this.getNextFreeProduct() ? '' : React.createElement(
                    "div",
                    { className: "mid-cart-free-products" },
                    this.showFreeProducts()
                ),
                React.createElement(
                    "div",
                    { className: "mid-cart-carousel" },
                    React.createElement(
                        "div",
                        { className: "mid-cart-carousel-title" },
                        Resx.App.SelectedForYou
                    ),
                    React.createElement(
                        "div",
                        { className: "mid-cart-carousel-body" },
                        this.renderCarouselItems()
                    )
                )
            );
        }
    }]);
    return MidCart;
}(_react.Component);

MidCart.propTypes = {
    cart: _propTypes2.default.object.isRequired,
    midCartClose: _propTypes2.default.func,
    submitChanges: _propTypes2.default.func.isRequired,
    updateMidCartVisibility: _propTypes2.default.func.isRequired,
    deliveryTypes: _propTypes2.default.array,
    carouselItems: _propTypes2.default.array,
    freeItems: _propTypes2.default.array,
    settings: _propTypes2.default.object
};

function mapStateToProps(state) {
    return {
        cart: state.cart,
        settings: state.settings
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, {
    updateMidCartVisibility: _actions2.default.updateMidCartVisibility,
    submitChanges: _actions2.default.submitChanges
})(MidCart);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/MidCart.js
// module id = 1012
// module chunks = 0